import React from "react";
import { useTranslation } from "react-i18next";
import { ResultsContent } from "./results-content";

export default function ResultsData() {
	const { t } = useTranslation();

	return (
		<section className="l--content l--content--full">
			<div className="l--content__main">
				<div className="container">
					<div className="card--primary">
						<div className="card--primary__header">
							<h1 className="card--primary__title title--primary">
								{t<string>("RESULTS.TITLE")}
							</h1>
						</div>
						<ResultsContent />
					</div>
				</div>
			</div>
		</section>
	);
}
